import { Button, Dropdown, Tooltip } from "components/ui";
import React, { useContext, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { BsStars } from "react-icons/bs";
import ConfigPanelPostTypes from "../ConfigPanelPostTypes";
import ConfigPanelImageTypes from "../ConfigPanelImageTypes";
import ParticleBackground from 'react-particle-backgrounds'
import { particleBackgroundSettingsPrimary } from 'configs/particle-background.config';
import { CompanyContext } from "contexts/CompanyContext";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";
import PlusBadge from "components/shared/PlusBadge";
import { useWhitelabel } from "contexts/WhitelabelThemeContext";
import { ShapesBackground } from "components/shared";

const SuggestTemplate = ({
    generatePostsFromContexts,
    config,
    setConfig
}) => {
    const maxSelection = usePostGenerationQuantity();
    const maximumSelection = usePostGenerationQuantity(true);

    const [ isLoading, setIsLoading ] = useState(false);
    const { company } = useContext(CompanyContext);
    const { whitelabel } = useWhitelabel();

    const handleOnSubmit = async (quantity = maxSelection) => {
        setIsLoading(true);
        let contexts = Array(quantity).fill(``);
        generatePostsFromContexts(contexts);
    }

    return (
        <div className="w-full h-full flex items-start gap-4">
            <ShapesBackground />
            <div className="flex-1 flex flex-row gap-2 w-full h-full overflow-y-auto relative">
                {/* <ParticleBackground settings={particleBackgroundSettingsPrimary(whitelabel?.colors?.primary)} className="absolute" style={{ zIndex: 1 }}/> */}
                <div className='relative flex flex-col items-center justify-center w-full h-full gap-12 p-4 z-[10]'> 
                    <h1 className="mega-title text-center !text-4xl lg:!text-5xl !font-bold">👋&nbsp; Hey{company?.name ? <>, <span className="!text-primary-600 mega-title !text-4xl lg:!text-5xl !font-bold">{company?.name}!</span></> : <span className="text-primary-600">!</span>}</h1>
                    <p className="text-sm lg:text-lg text-tertiary-700 dark:text-gray-100 text-center">
                        Let {whitelabel?.name} suggest engaging social media posts.
                        <br />
                        Just select the <b>social network</b>, the <b>image type</b> and click on <b>Generate</b>!
                    </p>
                    <div className="bg-secondary-500 dark:bg-gray-700 rounded-2xl shadow-2xl min-w-[350px] z-10">
                        <div className="flex items-center">
                            <ConfigPanelPostTypes 
                                postType={config?.postType}
                                setPostType={(postType) => setConfig({...config, postType: postType})}
                                selectedPrompts={config?.prompts}
                                onSelectPrompt={(prompt) => {
                                    let prompts = config?.prompts || [];
                                    if (prompts?.find(e => e.id == prompt.id)) {
                                        prompts = prompts.filter(e => e.id != prompt.id);
                                    } else {
                                        prompts = [...prompts, prompt];
                                    }
                                    setConfig({...config, prompts: prompts})
                                }}
                                placement="top-start"
                                parentClassName="flex-auto"
                                className="ml-0 !pt-4 !pb-4 !px-4 !pl-5 !pr-5 !bg-secondary-500 dark:!bg-gray-700 !capitalize flex-1 text-center !justify-center"
                            />
                            <ConfigPanelImageTypes 
                                config={config}
                                setConfig={setConfig}
                                placement="top-end"
                                parentClassName="flex-auto"
                                className="ml-0 !pt-4 !pb-4 !px-4 !pl-5 !pr-5 !bg-secondary-500 dark:!bg-gray-700 !rounded-l-none border-l border-gray-100 dark:border-gray-600 !capitalize flex-1 text-center !justify-center"
                            />
                        </div>
                        <div className='flex items-center gap-2 w-full'>
                            <Dropdown
                                placement="top-end"
                                disabled={isLoading}
                                parentClassName="w-full"
                                renderTitle={
                                    <Button 
                                        loading={isLoading}
                                        disabled={isLoading}
                                        variant="ai" 
                                        size="md" 
                                        className="flex gap-2 items-center !text-sm flex-1 justify-center w-full !rounded-t-none"
                                        icon={<BsStars />}
                                    >
                                        <Trans i18nKey={`aiImage.generate`}>Generate</Trans>
                                    </Button>
                                }
                            >
                                {[...Array(maximumSelection).keys()].map((key) => (
                                    key+1 <= maxSelection 
                                    ? <Dropdown.Item 
                                        onClick={() => handleOnSubmit(key+1)} 
                                        className="py-2"
                                        key={key}
                                    >
                                        Generate {key+1} post{key != 0 && `s`}
                                    </Dropdown.Item>
                                    : <Dropdown.Item 
                                        onClick={(e) => e?.stopPropagation()} 
                                        className="py-2 flex items-center justify-between gap-6"
                                        key={key}
                                    >
                                        <span className='opacity-30'>Generate {key+1} post{key != 0 && `s`}</span>
                                        <PlusBadge 
                                            wrapperClassName={`shrink-0 -mr-0.5`}
                                            className={`text-2xl`} 
                                            feature={`Multiple AI Post Generation`}
                                            placement="right"
                                        />
                                    </Dropdown.Item>
                                ))}
                            </Dropdown>
                        </div>
                    </div>
                    <div className="flex items-center justify-center text-center -mt-4">
                        <span className="text-sm text-gray-500 dark:text-gray-600 max-w-[350px] w-[90%]">
                            <b>💡&nbsp; Tip:</b>{" "} you can always click on the prompt button next to the social network to select or add new styles to your posts!
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuggestTemplate;